import React, { useState, useEffect } from "react";
import { CircularProgress, Button } from "@mui/material/";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import makeStyles from "@mui/styles/makeStyles";
import actions from "../../Store/actions";
import AssetItem from "./AssetItem";
import { useNavigate, useParams } from "react-router-dom";
import { useToaster } from "../../common/hooks";
import styles from "./styles";
import { logToSentry } from "../../config/Sentry";

const Unchecked = ({ data, hdlShowMore, className }) => {
    const classes = makeStyles(styles)();
    const [unCheckedData, setUnCheckedData] = useState(data);
    const [mounted, setMounted] = useState(false);
    const dispatch = useDispatch();
    const params = useParams();
    const { auditId } = params;
    const { t } = useTranslation();
    const toast = useToaster();

    const [assets, setAssets] = useState([
        <div
            key={0}
            // using style instead of className as on render it does not load classes
            style={{
                display: "flex",
                justifyContent: "center",
                padding: "3rem",
            }}
        >
            <CircularProgress />
        </div>,
    ]);

    let navigate = useNavigate();

    const onDeferClick = (auditAsset) => async () => {
        try {
            const curretTimeStamp = Date.now();
            const updAuditAsset = {
                ...auditAsset,
                deferredTimestamp: curretTimeStamp,
            };
            /** Update timestamp for current data*/
            setUnCheckedData((data) => {
                const dataList = [...data];
                setMounted(true); //Set it to true as the cards has to sort
                dataList.map((item) => {
                    if (item.id === auditAsset.id)
                        item.deferredTimestamp = curretTimeStamp;
                });
                dataList.sort(
                    (a, b) => a.deferredTimestamp - b.deferredTimestamp
                );
                return dataList; // <-- now sorted ascending
            });
            await dispatch(
                actions.auditAssets.create.writeRequest([updAuditAsset])
            );
        } catch (error) {
            console.log(error);
            toast.error(t("errors.deferAsset"));
            logToSentry(`onDeferClick: deferAsset:`, {
                error,
                errStr: error.toString(),
            });
        }
    };

    const onExcludeClick = (auditAsset: any) => () => {
        try {
            const assetId = auditAsset.id;
            dispatch(actions.auditAssets.create.itemSet(auditAsset));
            navigate(`/auth/audits/${auditId}/assets/${assetId}/exclude`);
        } catch (error) {
            console.log(error);
            toast.error(t("errors.excludeAsset"));
            logToSentry(`onExcludeClick:`, {
                error,
                errStr: error.toString(),
            });
        }
    };
    useEffect(() => {
        const items = unCheckedData.map((item) => (
            <AssetItem
                key={item.id}
                assetId={item.id}
                assetType="unchecked"
                itemContent={item}
                onDefer={onDeferClick(item)}
                onExclude={onExcludeClick(item)}
            />
        ));
        setAssets(items);
        // Don't set the data if the mounting is false
        if (!mounted) setUnCheckedData(data);
    }, [unCheckedData, data]);

    const onShowMore = () => {
        setMounted(false); // Set mounted to false for bubbling
        hdlShowMore();
    };
    return (
        <div className={classes.listContainer}>
            {assets}
            {assets.length > 1 ? (
                <Button onClick={onShowMore} className={className}>
                    {t("showMore").toUpperCase()}
                </Button>
            ) : null}
        </div>
    );
};

export default Unchecked;
